import { cn } from '@/lib/cn.js';

export interface AvatarProps {
  name: string;
  size?: number;
  className?: string;
}

const HUES = [200, 30, 150, 280, 330, 100, 250, 10] as const;

export function Avatar({ name, size = 24, className }: AvatarProps) {
  const initials =
    name
      .split(' ')
      .map((p) => p[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase() || '?';

  const hue = HUES[name.length % HUES.length];

  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded-full font-semibold text-ink-900 shrink-0',
        className
      )}
      style={{
        width: size,
        height: size,
        background: `oklch(0.78 0.12 ${hue})`,
        fontSize: Math.max(9, size * 0.42),
        letterSpacing: '0.02em',
      }}
      title={name}
      aria-label={name}
    >
      {initials}
    </span>
  );
}
